import { ReferenceInput, AutocompleteInput, SelectInput, required, useSimpleFormIteratorItem } from "react-admin";
import { Grid } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import { specialistRequests } from "api/specialistApi";

const SpecializationOptionFields = () => {
  const { index } = useSimpleFormIteratorItem();
  const { setValue } = useFormContext();

  const prefix = `specializationOptions.${index}`;
  const specializationId = useWatch({ name: `${prefix}.specializationId` });

  const handleSpecializationChange = () => {
    setValue(`${prefix}.receptionTypeId`, null);
    setValue(`${prefix}.trainingBuildingId`, null);
  };

  return (
    <>
      <Grid
        item
        xs={12}
        md={6}
        xl={4}
      >
        <ReferenceInput
          source="specializationId"
          reference={specialistRequests.getSpecializationsSelect()}
        >
          <AutocompleteInput
            validate={[required()]}
            optionText="nameBg"
            label="Специалност"
            fullWidth
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            onChange={handleSpecializationChange}
          />
        </ReferenceInput>
      </Grid>

      {specializationId && (
        <>
          <Grid
            item
            xs={12}
            md={6}
            xl={4}
          >
            <ReferenceInput
              source="receptionTypeId"
              reference={specialistRequests.getSpecialistReceptionTypesSelect(specializationId)}
            >
              <SelectInput
                validate={[required()]}
                label="Тип прием"
                optionText="nameBg"
                fullWidth
              />
            </ReferenceInput>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            xl={4}
          >
            <ReferenceInput
              source="trainingBuildingId"
              reference={specialistRequests.getTrainingBuildingsSelect()}
              filter={{ SpecializationId: specializationId }}
            >
              <AutocompleteInput
                label="База за обучение"
                optionText="buildingNameBg"
                fullWidth
                filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
              />
            </ReferenceInput>
          </Grid>
        </>
      )}
    </>
  );
};

export default SpecializationOptionFields;
